import { api } from '@/create//composables/api';
import { baseURL } from "@/create//composables/const";
import { dateFormatter } from '@/create/composables/utils';

const apiVersion = 2

// адреса по каталогу 
export async function getKladr(login, term, type, city_code) {
  try {
    const data = {
      action: "kladrlife",
      login,
      kladr: {
        term,
        type,
        city_code
      },
    } 

    const res = await api.post(baseURL, data);

    if (res.data.state === "success" && res.data.kladr.length > 0) {
        return res.data.kladr;
    }
  } catch (e) {
    console.log('kladr error -', e);
  }
}

// JWT токен проверка
export async function checkJWT(login, jwt_token ) {
  try {
    const data = {
      format: "json",
      ver: apiVersion,
      action: "get_jwt_data",
      object: "contract",
      login,
      jwt_token,
    }
    const res = await api.post(baseURL, data);

    if (res.data.state === 'success') {
      return (res.data);
    }
  } catch (e) {
    console.log('checkJWT', e);
  }
}

// ссылка на госуслуги для авторизации
export async function checkInfoWithGosuslugiAuth(login, filledFormData) {
  try {
    const data = {
      format: "json",
      ver: apiVersion,
      action: "esia_url",
      login,
      redirect_url: location.origin + location.pathname,
      data: filledFormData,                                                                     // все поля объекта для передачи должны быть с маленькими буквами, госуслуги их потом так вернет
      last_name: filledFormData.insurer.find(i => i.validation === 'last_name').value,
      first_name: filledFormData.insurer.find(i => i.validation === 'first_name').value,
      middle_name: filledFormData.insurer.find(i => i.validation === 'middle_name').value,
      serial: filledFormData.documents.find(i => i.fieldName === 'serial').value,
      number: filledFormData.documents.find(i => i.fieldName === 'number').value,
      date: dateFormatter('-', filledFormData.documents.find(i => i.fieldName === 'date').value)
    }

    const res = await api.post(baseURL, data);
    if (res.data.state === 'success') {
      window.open(res.data.esia_link, '_self')
    }
  } catch (e) {
    console.log('checkInfoWithGosuslugiAuth -', e);
  }
}

// получение данных от госуслуг
export async function checkInfoFromGosuslugi(login) {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('code') || !urlParams.has('state')) {
      return null
    }

    const data = {
      format: "json",
      ver: apiVersion,
      action: "esia_get_data_check_value",
      login,
      code: urlParams.get('code'),
      state: urlParams.get('state'),
    }

    const res = await api.post(baseURL, data);
    return res.data;
  } catch (e) {
    console.log('checkInfoFromGosuslugi - ' + e);
  }
}

// создать и отправить смс код
export async function getSMSCode(contract_id, phone) {
  try {
    const data = {
      format: "json",
      ver: 4,
      action: "generatesigncheckcode",
      code_sign: "contact",
      id_sign: contract_id,
      phone,
      methods: "SMS"
    }
    const res = await api.post(baseURL, data);
    return res.data;
  } catch (e) {
    console.log('getSMSCode - ' + e);
  }
}

// проверить правильность введенного кода
export async function checkSMSCode(contract_id, smsCode) {
  try {
    const data = {
      format: "json",
      ver: 4,
      action: "comparesigncheckcode",
      code_sign: "contact",
      id_sign: contract_id,
      check_sign: smsCode,
    }
    const res = await api.post(baseURL, data);
    return res.data;
  } catch (e) {
    console.log('checkSMSCode - ' + e);
  }
}

// получение документов кида и полиса
export async function getKidPolicyCreateContract(login, action, someData) {
  try {
    let agreement, contacts, documents, addresses, beneficiaries

    if (someData.agreement) {
      agreement = {
        ins_calc_type: '1',
        payment_order: '0',
        currency: "rur",
        insurer: 0,
        bank_policy_premium: 0,
      }
      agreement = {...agreement, ...someData.agreement}
    }

    if (someData.contacts) {
      contacts = someData.contacts.map((item, index) => {
        const keys = item.map(i => i.validation).filter(i => i !== '')
        const obj = {}
        for (let i = 0; i < item.length; i++) {
          if (keys[i]) {
            obj[keys[i]] = item.find(itm => itm.validation === keys[i]).value
          }
        }
        obj.documents = [index.toString()]
        obj.addresses = [index.toString(), (index+1).toString()]
        obj.citizenship === 'РФ' ? obj.citizenship = 'rf' : ''
        obj.phone = obj.phone.match(/([0-9]|[+])/g).join('')
        obj.birth_date = dateFormatter('-', obj.birth_date)
        return obj
      })
    }

    if (someData.documents) {
      documents = someData.documents.map((item, index) => {
        const keys = item.map(i => i.fieldName)
        const obj = {}
        for (let i = 0; i < item.length; i++) {
          if (keys[i]) {
            obj[keys[i]] = item.find(itm => itm.fieldName === keys[i]).value
          }
        }
        obj.type === 'Паспорт РФ' ? obj.type = '1' : obj.type = '2'
        obj.date = dateFormatter('-', obj.date)
        return obj
      })
    }

    if (someData.addresses) {
      addresses = someData.addresses.map((item, index) => {
        const keys = item.map(i => i.validation).filter(i => i !== '')
        const obj = {}
        for (let i = 0; i < item.length; i++) {
          if (keys[i]) {
            obj[keys[i]] = item.find(itm => itm.validation === keys[i]).value
          }
          if (keys[i] === 'city') {
            obj.city_code = item[i].key
          }
          if (keys[i] === 'street') {
            obj.street_code = item[i].key
          }
        }
        return obj
      })
    }

    if (someData.beneficiaries) {
      beneficiaries = someData.beneficiaries.map((item, index) => {
        const keys = item.map(i => i.fieldName)
        const obj = {}
        for (let i = 0; i < item.length; i++) {
          if (keys[i]) {
            obj[keys[i]] = item.find(itm => itm.fieldName === keys[i]).value
          }
        }
        obj.addresses = [(addresses.length + index).toString()]
        obj.birth_date = dateFormatter('-', obj.birth_date)
        return obj
      })
      agreement.beneficiaries = beneficiaries.map((item, index) => ({
        relationship: item.relationship,
        part_of_ins_sum: item.part,
        contact: contacts.length + index
      }));
      contacts = contacts.concat(beneficiaries)
      const beneficiariesAddresses = beneficiaries.map(item => ({"street": item.address}))
      addresses = addresses.concat(beneficiariesAddresses)
    }

    const data = {
      action,
      format: "json",
      ver: 4,
      object: "contract",
      login,
      agreement,
      contacts,
      documents,
      addresses,
    };

    const res = await api.post(baseURL, data);
    if (res.data.state === 'success') {
      return res.data
    }
  } catch (e) {
    console.log('getKidPolicyCreateContract -', e);
  }
}

// получение ссылки для оплаты
export async function getPayLink(login, data) {
  try {
    const request = {
      format: "json",
      ver: 4,
      action: "creatpay",
      login,
      policy_id: data.contractId,
      phone: data.phone,
      email: data.email,
    }

    const res = await api.post(baseURL, request);
    if (res.data.state === 'success' && res.data.url) {
      window.open(res.data.url.link, '_self')
    }
  } catch (e) {
    console.log('getPayLink -', e);
  }
}
